export default {"src":"/_next/static/media/amazon_white.ae74ba67.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};